<ng-container *ngIf="toasts$ | async as toasts">
  <ngb-toast
    *ngFor="let toast of toasts"
    [header]="toast.header"
    [autohide]="autohide"
    (hidden)="remove(toast)"
    [class]="toast.classname"
    [delay]="toast.delay"
    (mouseenter)="autohide = false"
    (mouseleave)="autohide = true">
    <div class="d-flex align-items-center">
      <div>
        <span class="material-icons text-info align-middle me-2" *ngIf="toast.type === 'information'">info</span>
        <span class="material-icons text-success align-middle me-2" *ngIf="toast.type === 'success'">thumb_up</span>
        <span class="material-icons align-middle me-2" *ngIf="toast.type === 'warning'">warning</span>
        <span class="material-icons text-dark align-middle me-2" *ngIf="toast.type === 'user'">people</span>
        <span class="material-icons align-middle me-2" *ngIf="toast.type === 'error'">error_outline</span>
      </div>
      <div class="flex-fill">{{ toast.text }}</div>
    </div>
  </ngb-toast>
</ng-container>
